"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = require("@eres/rest");
var config_1 = __importDefault(require("../config"));
var js_base64_1 = require("js-base64");
var core_1 = require("@eres/core");
function loginByUAEPass(token) {
    var credentials = getCredential("UAEPass", token);
    return auth(credentials, undefined, false, true);
}
exports.loginByUAEPass = loginByUAEPass;
function loginByUAEPassCode(code) {
    var credentials = getCredential("UAEPassCode", code);
    return auth(credentials, undefined, false, true);
}
exports.loginByUAEPassCode = loginByUAEPassCode;
function loginByEID(eid, dob, isResend) {
    if (isResend === void 0) { isResend = false; }
    var credentials = getCredential("EmiratesId", eid);
    return auth(credentials, dob, isResend, true);
}
exports.loginByEID = loginByEID;
function loginByEjari(user, passwd) {
    var credentials = getCredential("Ejari", user, passwd);
    return auth(credentials, undefined, false, true);
}
exports.loginByEjari = loginByEjari;
function authenticate(method, id, dob, isResend) {
    if (isResend === void 0) { isResend = false; }
    var credentials = getCredential(method, id);
    return auth(credentials, dob, isResend, true);
}
exports.authenticate = authenticate;
function verifyOTP(method, id, otp, dob) {
    var credentials = getCredential(method, id, otp);
    return auth(credentials, dob);
}
exports.verifyOTP = verifyOTP;
function loginByCertificate(certInfo, dob, isResend) {
    if (isResend === void 0) { isResend = false; }
    var credentials = getCredential("TitleDeed", certInfo);
    return auth(credentials, dob, isResend, true);
}
exports.loginByCertificate = loginByCertificate;
function loginByMobile(mobile, dob, isResend) {
    if (isResend === void 0) { isResend = false; }
    var credentials = getCredential("Mobile", mobile);
    return auth(credentials, dob, isResend, true);
}
exports.loginByMobile = loginByMobile;
function loginByEmail(email, dob, isResend) {
    if (isResend === void 0) { isResend = false; }
    var credentials = getCredential("Email", email);
    return auth(credentials, dob, isResend, true);
}
exports.loginByEmail = loginByEmail;
function me() {
    return rest_1.httpPost(authUri(false) + "/loadprofile", undefined);
}
exports.me = me;
function getCredential(method, id, pass) {
    if (pass === void 0) { pass = ""; }
    return {
        "Method": method,
        "MethodIdentity": id,
        "MethodPasscode": pass,
        "DeviceKey": "MyPC",
        "ApplicationKey": "MyBrowser",
        "Platform": "DESKTOP",
    };
}
exports.getCredential = getCredential;
function auth(credentials, dob, isResend, noToken) {
    if (isResend === void 0) { isResend = false; }
    if (noToken === void 0) { noToken = false; }
    var authData = js_base64_1.Base64.encode(JSON.stringify(credentials));
    var headers = {
        "Authorization": "Basic " + authData,
    };
    if (noToken)
        headers.Token = null;
    if (dob) {
        try {
            var d = dob.asDate();
            dob = core_1.DateUtil.formatDate(d, "YYYY-MM-DD", "en");
        }
        catch (e) {
        }
    }
    return rest_1.httpPost(authUri(isResend), dob ? { dateOfBirth: dob } : { dateOfBirth: "01/01/01" }, headers);
}
exports.auth = auth;
function authUri(isResend) {
    if (isResend === void 0) { isResend = false; }
    return config_1.default.authAPI().endPoint() + ("authentication" + (isResend ? "/resend" : ""));
}
exports.authUri = authUri;
function guestAuthenticate() {
    var credentials = generateGuestCredential();
    return auth(credentials, undefined);
}
exports.guestAuthenticate = guestAuthenticate;
function generateGuestToken() {
    return js_base64_1.Base64.encode(JSON.stringify(generateGuestCredential()));
}
exports.generateGuestToken = generateGuestToken;
function generateGuestCredential() {
    return {
        "ApplicationKey": "MyBrowser",
        "MethodIdentity": "guest",
        "MethodPasscode": "123",
        "Platform": "DESKTOP",
        "Method": "ANONYMOUS",
        "DeviceKey": "MyPC",
    };
}
